import { Block } from 'baseui/block';
import { useGetMatchQuery } from '../../../../services/objects';
import { modelId } from './types'
import { modelId as modelIdHC } from '../../HeatingCoolings/P_HeatingCoolingOutlet/types'
import { FaGripfire } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { ValueDisplay } from '../../../components/ValueDisplay';
import { Badge } from 'baseui/badge';
import { styled, useStyletron } from 'baseui';
import { useState, useEffect } from 'react';

const ActiveHeatingOutlets = (props: { parentId: string, parentResourceGroupId: string }) => {
    const [, theme] = useStyletron();
    const [cnt, setCnt] = useState(0);

    const { data: active } = useGetMatchQuery({
        objectId: props.parentId,
        resourceGroupId: props.parentResourceGroupId,
        hops: '..2',
        relationship: 'Contains',
        modelId: modelId,
        queryParameters: 'IsOn=true'
    });

    const { data: activeHC } = useGetMatchQuery({
        objectId: props.parentId,
        resourceGroupId: props.parentResourceGroupId,
        hops: '..2',
        relationship: 'Contains',
        modelId: modelIdHC,
        queryParameters: 'IsHeating=true && IsOn=true'
    });

    useEffect(() => {
        if (!active && !activeHC)
            return;

        const iCnt = (active?.length? active?.length : 0) + (activeHC?.length? activeHC?.length:0);
        setCnt(iCnt);

    }, [active, activeHC])

    return (<>
        {cnt > 0 &&
            <Badge color='primary' hierarchy='secondary' content={
                <Block display={'flex'} gridGap={theme.sizing.scale200} alignItems={'baseline'}>
                    <FaGripfire color={theme.colors.negative400}></FaGripfire>
                    <b>{cnt}</b>
                    {cnt === 1 ?
                        <FormattedMessage id="P_HeatingOutlet.HeatingOutletON" defaultMessage="Heating outlet ON" />
                        :
                        <FormattedMessage id="P_HeatingOutlet.HeatingOutletsON" defaultMessage="Heating outlets ON" />
                    }
                </Block>
            } ></Badge>
        }

    </>)
}

export default ActiveHeatingOutlets;
